import Model from '@/models/Model.js';

export default class AutomatedSurveyAssignment extends Model {
    static entity = 'automated_survey_assignments';

    static modelName = 'AutomatedSurveyAssignment';

    static fields() {
        return {
            id: this.attr(null),
            user_id: this.attr(null),
            course_id: this.attr(null),
            activity_id: this.attr(null),
            survey_id: this.attr(null),
            evaluation_template_id: this.attr(null),
            survey_attempt_id: this.attr(null),
            automated_survey_id: this.attr(null),
            notification_id: this.attr(null),
            subject_id: this.attr(null),
            subject_type: this.attr(null),
            subject_type_entity: this.attr(null),
            triggered_at: this.attr(null),
            locked_at: this.attr(null),
            required_at: this.attr(null),
            completed_at: this.attr(null),
            is_anonymous: this.attr(null),
            time_limit: this.attr(null),
            is_locked_now: this.boolean(false),
            is_in_progress: this.boolean(false),
            started_at: this.attr(null),

            ...super.fields(),
            deleted_at: this.attr(null),

            user: this.belongsTo('users', 'user_id'),
            course: this.belongsTo('courses', 'course_id'),
            activity: this.belongsTo('activities', 'activity_id'),
            survey: this.belongsTo('quizzes', 'survey_id'),
            subject: this.morphTo('subject_id', 'subject_type_entity'),
            // survey_attempt: this.belongsTo('quiz_attempts', 'survey_attempt_id'),
            automated_survey: this.belongsTo('automated_surveys', 'automated_survey_id'),
        };
    }

    get time_limit_display() {
        return this.fromSecondsToDisplay('time_limit');
    }
}
